export default {
    container: {
        marginTop: "20px",
        width: "60%"
    },
    selectGroupContainer: {
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        gap: "40px",
        margin: "80px 0px",
    }
}